import {
  WbCardActions,
  WbCardActionsPinned,
  WbTooltip,
  WbButton,
} from '@agilelab/plugin-wb-platform';
import { Typography, makeStyles } from '@material-ui/core';
import { DateTime } from 'luxon';
import { FC } from 'react';
import { DescriptorViewToggle } from './DescriptorViewToggle';
import { useEditorPageContext } from '../context/useEditorPageContext';
import CachedIcon from '@material-ui/icons/Cached';

const useStyles = makeStyles(
  () => ({
    root: {
      width: '100%',
      flexShrink: 0,
      minWidth: 0,
      flex: 1,
    },
    updatedAt: {
      fontStyle: 'italic',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      marginLeft: 'auto',
    },
  }),
  { name: 'DescriptorCardActions' },
);

export const DescriptorCardActions: FC = () => {
  const classes = useStyles();
  const {
    descriptorState,
    fetchDescriptor,
    fetchDescriptorWithComponents,
    updatedAt,
  } = useEditorPageContext();

  const isLoading =
    descriptorState.loading || descriptorState.value === undefined;

  return (
    <WbCardActions breakpoint="sm">
      <DescriptorViewToggle />

      {updatedAt && (
        <WbCardActionsPinned position="bottom">
          <Typography
            role="status"
            variant="caption"
            color="textSecondary"
            className={classes.updatedAt}
          >
            {`Updated at: ${DateTime.fromMillis(updatedAt).toFormat(
              'dd/MM/yyyy HH:mm',
            )}`}
          </Typography>
        </WbCardActionsPinned>
      )}

      <WbTooltip title="Refresh descriptor by reading again all the values from the repositories. After you make a change on the repository files, click this button to reload and see the changes in the descriptor.">
        <span>
          <WbButton
            variant="outlined"
            onClick={() => {
              fetchDescriptor(true, true);
              fetchDescriptorWithComponents(true, false);
            }}
            label="Refresh"
            icon={<CachedIcon />}
            disabled={isLoading}
            fullWidthUnderBreakpoint="sm"
          />
        </span>
      </WbTooltip>
    </WbCardActions>
  );
};
